import { DEFAULT_VIDEO_NAME } from '@anm/constants/my-videos';
import formatName from '@anm/helpers/formatName';
import { MediaObject } from '@anm/hosting-player';

export const getDownloadSources = (sources = [] as MediaObject[]): MediaObject[] => {
  const downloadSources = sources.sort(({ isOriginal }) => {
    if (isOriginal) return -1;
    return 1;
  });

  const canAddStreamVideoToOptions = true;

  if (canAddStreamVideoToOptions) return downloadSources;

  return downloadSources.filter(s => !new RegExp('m3u8').test(s.path));
};

export const getFormattedName = (name?: string) => {
  if (!name) return DEFAULT_VIDEO_NAME;

  return formatName(name);
};
